import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';

interface TabItem extends MenuItem {
  tabUrl: string;
}

@Component({
  selector: 'app-style-guide',
  templateUrl: './style-guide.component.html',
  styleUrls: ['./style-guide.component.scss'],
})
export class StyleGuideComponent implements OnInit {
  tabItems: TabItem[] = [
    {
      label: 'Colors',
      command: this.onTabClick.bind(this, '/style-guide/colors'),
      tabUrl: '/style-guide/colors',
      automationId: 'style-guide-colors',
    },
    {
      label: 'Typography',
      command: this.onTabClick.bind(this, '/style-guide/typography'),
      tabUrl: '/style-guide/typography',
      automationId: 'style-guide-typography',
    },
    {
      label: 'Icons',
      command: this.onTabClick.bind(this, '/style-guide/icons'),
      tabUrl: '/style-guide/icons',
      automationId: 'style-guide-icons',
    },
    {
      label: 'Styled Components',
      command: this.onTabClick.bind(this, '/style-guide/styled-components'),
      tabUrl: '/style-guide/styled-components',
      automationId: 'style-guide-styled-components',
    },
    {
      label: 'Unstyled Components',
      command: this.onTabClick.bind(this, '/style-guide/unstyled-components'),
      tabUrl: '/style-guide/unstyled-components',
      automationId: 'style-guide-unstyled-components',
    },
  ];

  activeTabItem = this.tabItems[0];

  constructor(private router: Router) {}

  ngOnInit() {
    const activeTabItem = this.tabItems.find(
      (tabItem: TabItem) => tabItem.tabUrl.toLowerCase() === this.router.url.toLowerCase()
    );

    if (activeTabItem) this.activeTabItem = activeTabItem;
  }

  onTabClick(link: string) {
    this.router.navigate([link]);
  }
}
